import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const csmExperienceMessagingAppsRoute: InvariantJiraRoute = {
	name: 'csm-experience-messaging-apps',
	path: '/jira/customer-service-management/experiences/:projectKey/settings/:helpCenterId/messaging-apps',
	exact: true,
};
